import { createIcon } from '@chakra-ui/react';
import colors from 'src/theme/colors';

export default createIcon({
  displayName: 'CrossIcon',
  viewBox: '0 0 11 11',
  path: [
    <path
      key="a"
      d="M1 10L10 1"
      stroke={colors.AlituPurpleGrey}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      key="b"
      d="M1 1L10 10"
      stroke={colors.AlituPurpleGrey}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
